import { differenceInMinutes, isSameDay } from 'date-fns';
import {
    formatDateLong,
    formatDateTime,
    formatTime,
    minutesToDuration,
} from '~/lib/DateTime.js';
import {
    clientFormatDateLong,
    clientFormatDateTime,
    clientFormatTime,
} from '~/public/lib/ClientDateTime.js';

const StartEndDateTime = ({ start, end, clientTz }) => {
    return (
        <>
            {isSameDay(new Date(start), new Date(end)) ? (
                /*Starts and ends on the same day*/
                <div>
                    <div className="">
                        {clientFormatDateLong(start, clientTz)}
                    </div>
                    <div className="text-gray-500">
                        {clientFormatTime(start, clientTz)}-
                        {clientFormatTime(end, clientTz)} (
                        {minutesToDuration(
                            differenceInMinutes(new Date(end), new Date(start)),
                        )}
                        )
                    </div>
                </div>
            ) : (
                /*Different days for start/end*/
                <div>
                    {clientFormatDateTime(start, clientTz)}-
                    {clientFormatDateTime(end, clientTz)}
                </div>
            )}
        </>
    );
};

export default StartEndDateTime;
